import { OBSIDIAN } from 'HubStyleTokens/colors';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "VerticalSeparator__Container",
  componentId: "ugwxm3-0"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;color:", ";"], OBSIDIAN);
const VerticalSeparator = ({
  message
}) => {
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: message
    })
  });
};
export default VerticalSeparator;